import ImportModal from "./import_modal";
import { hideModal } from "../../actions/modal";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import { submit, formValueSelector } from "redux-form";

function mapStateToProps(state) {
  return {
    currentRSSValue: formValueSelector("feed-import")(state, "feedURL"),
    isLoading: state.showFeedImport.isLoading || state.episodeFeedImport.isLoading,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    closeModal: () => {
      dispatch(hideModal());
    },
    submitForm: () => {
      dispatch(submit("feed-import"));
    },
  };
}

const ImportModalWrapper = withRouter(connect(mapStateToProps, mapDispatchToProps)(ImportModal));

export default ImportModalWrapper;
